export const ViewDeskIcon: React.FC<
  React.SVGProps<SVGSVGElement> & {
    pathProps?: React.SVGProps<SVGPathElement>;
  }
> = ({ pathProps, ...props }) => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.75004 3.75C7.08577 3.75 6.46184 3.92272 5.92071 4.22569L4.83081 3.13579C5.66554 2.57633 6.66968 2.25 7.75004 2.25C10.6495 2.25 13 4.60051 13 7.5C13 10.3995 10.6495 12.75 7.75004 12.75C6.66971 12.75 5.6656 12.4237 4.83088 11.8643L5.92078 10.7744C6.4619 11.0773 7.0858 11.25 7.75004 11.25C9.82111 11.25 11.5 9.57107 11.5 7.5C11.5 5.42893 9.82111 3.75 7.75004 3.75ZM1.46973 4.03039L4.76262 7.32328C4.86025 7.42091 4.86025 7.5792 4.76262 7.67683L1.46973 10.9697L2.53039 12.0304L5.82328 8.73749C6.5067 8.05408 6.5067 6.94604 5.82328 6.26262L2.53039 2.96973L1.46973 4.03039Z"
      fill="white"
      {...pathProps}
    />
  </svg>
);
